/**
 * @generated SignedSource<<1d06c06c096b5b8cb104ff638272f37d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type GeneralAssetManufacturerInputGeneralAssetManufacturersQuery$variables = {};
export type GeneralAssetManufacturerInputGeneralAssetManufacturersQueryVariables = GeneralAssetManufacturerInputGeneralAssetManufacturersQuery$variables;
export type GeneralAssetManufacturerInputGeneralAssetManufacturersQuery$data = {
  readonly generalAssetManufacturers: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string;
      };
    }>;
  };
};
export type GeneralAssetManufacturerInputGeneralAssetManufacturersQueryResponse = GeneralAssetManufacturerInputGeneralAssetManufacturersQuery$data;
export type GeneralAssetManufacturerInputGeneralAssetManufacturersQuery = {
  variables: GeneralAssetManufacturerInputGeneralAssetManufacturersQueryVariables;
  response: GeneralAssetManufacturerInputGeneralAssetManufacturersQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "GeneralAssetManufacturerConnection",
    "kind": "LinkedField",
    "name": "generalAssetManufacturers",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GeneralAssetManufacturerEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "GeneralAssetManufacturer",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "GeneralAssetManufacturerInputGeneralAssetManufacturersQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "GeneralAssetManufacturerInputGeneralAssetManufacturersQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "e2c779bbbafce897116b495788fc4d14",
    "id": null,
    "metadata": {},
    "name": "GeneralAssetManufacturerInputGeneralAssetManufacturersQuery",
    "operationKind": "query",
    "text": "query GeneralAssetManufacturerInputGeneralAssetManufacturersQuery {\n  generalAssetManufacturers {\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "17dce63285780b6ccc2f13f3510382ba";

export default node;
